import { Injectable } from "@angular/core";
import { MenuItem } from "primeng/api";
import { Subject } from "rxjs";

@Injectable({
    providedIn: "root",
})
export class LoaderService {
    isLoading = new Subject<boolean>();
    sideBarItems: MenuItem[] = [
        {
            id: "coverage",
            icon: "material-symbols-outlined ms-public",
            routerLink: "/pages/coverage",
            label: "menu-items.map",
        },
        {
            icon: "material-symbols-outlined ms-directions-boat",
            routerLink: "/pages/vessels",
            label: "menu-items.my-fleet",
        },
        {
            icon: "material-symbols-outlined ms-radar",
            routerLink: "/pages/vessel",
            label: "menu-items.operation",
        },
        {
            icon: "material-symbols-outlined ms-speed",
            routerLink: "/pages/performance",
            label: "menu-items.performance",
        },
        {
            icon: "material-symbols-outlined ms-show-chart",
            routerLink: "/pages/analytics",
            label: "menu-items.maintenance",
        },
        {
            icon: "material-symbols-outlined ms-fork-right",
            routerLink: "/pages/routing",
            label: "menu-items.routing",
        },
        {
            icon: "material-symbols-outlined ms-query-stats",
            label: "menu-items.cii",
            routerLink: "/pages/cii",
        },
        {
            icon: "material-symbols-outlined ms-bar-chart",
            routerLink: "/pages/explore",
            label: "menu-items.explore",
        },
        {
            icon: "material-symbols-outlined ms-equalizer",
            routerLink: "/pages/reports",
            label: "menu-items.reports",
        },
        {
            id: "administration",
            routerLink: "/pages/admin",
            icon: "material-symbols-outlined ms-settings",
            label: "menu-items.administration",
        },
    ];

    show() {
        this.isLoading.next(true);
    }

    hide() {
        this.isLoading.next(false);
    }
}
